// in this case we have one component for simulate complex formats for text
// and with work it canvas together then we created one rich text with quill js
// to do job of complex formatted styles and finally when box of text closed
// and we transform the box with rich text to image
// we use a rectangle from Konva as text box and your transformer for resize

//the text box opens after a callback on double clicking on the konva rectangle
import html2canvas from "html2canvas";
import Konva from "konva";
import { cloneDeep } from "lodash";

import React, {
  MutableRefObject,
  useCallback,
  useEffect,
  useRef,
  useState
} from "react";
import { Image as ImageKonva, Rect, Transformer } from "react-konva";
import { Html } from "react-konva-utils";
import ReactQuill, { Quill } from "react-quill";
import useImage from "use-image";
import * as QuillText from "quill";
import Delta from "quill-delta/lib/delta";

//set up interfaces
interface SelectionProps {
  index: number;
  length: number;
}

interface ImageRichTextProps {
  shapeProps?: any;
  selectedObject?: Konva.Shape;
  setSelectedObject?: any;
  addToHistory?: any;
  currentMultipleSelection?: any;
  setObjectScreen?: any;
  transformerSelectedObject?: any;
  quillRef?: MutableRefObject<ReactQuill>;
  requestUpdateText?: () => void;
  textRich?: MutableRefObject<string>;
  isEditing?: "closed" | "blocked" | "open";
  setIsEditing: React.Dispatch<
    React.SetStateAction<"closed" | "blocked" | "open">
  >;
  blockingKeyboard: boolean;
  setBlockingKeyboard: React.Dispatch<React.SetStateAction<boolean>>;
  templateStartedShared: boolean;
  setTemplateStartedShared: React.Dispatch<React.SetStateAction<boolean>>;
  oldContentsState: null | QuillText.DeltaStatic;
  setOldContentsState: null | React.Dispatch<
    React.SetStateAction<QuillText.DeltaStatic>
  >;
  newContentsState: null | QuillText.DeltaStatic;
  setNewContentsState: null | React.Dispatch<
    React.SetStateAction<QuillText.DeltaStatic>
  >;
  selectionCursor: SelectionProps;
  setSelectionCursor: React.Dispatch<React.SetStateAction<SelectionProps>>;
  findDiff: () => void;
  buttonRef: React.MutableRefObject<HTMLButtonElement>;
  isEditingQuill: boolean;
  setIsEditingQuill: React.Dispatch<React.SetStateAction<boolean>>;
  newDelta: null | QuillText.DeltaStatic;
  setNewDelta: React.Dispatch<React.SetStateAction<QuillText.DeltaStatic>>;
  newChanges: string;
  setNewChanges: React.Dispatch<React.SetStateAction<string>>;
  oldContentsRef?: null | React.MutableRefObject<QuillText.DeltaStatic>;
  newContentsRef?: null | React.MutableRefObject<QuillText.DeltaStatic>;
  getQuillCursorRef?: null | React.MutableRefObject<SelectionProps>;
  isNewTextRef?: React.MutableRefObject<boolean>;
  isTypingQuillRef?: React.MutableRefObject<boolean>;
  quillRefComponent?: React.MutableRefObject<ReactQuill>;
  whichUserEdited?: React.MutableRefObject<string>;
  nameOfCurrentUser?: React.MutableRefObject<string>;
  interceptModifications?: React.MutableRefObject<boolean>;
  textIsChanged: React.MutableRefObject<boolean>;
  blockRenderImage?: React.MutableRefObject<boolean>;
  blockBackspace: React.MutableRefObject<boolean>;
  hasGroupShared?: React.MutableRefObject<boolean>;
  whichKeyPress?: React.MutableRefObject<string>;
  selectionFormatText?: React.MutableRefObject<QuillText.StringMap>;
}

const ImageRichText = ({
  shapeProps,
  selectedObject,
  setSelectedObject,
  addToHistory,
  currentMultipleSelection,
  setObjectScreen,
  quillRef,
  isEditing,
  setIsEditing,
  setBlockingKeyboard,
  newContentsRef,
  oldContentsRef,
  isNewTextRef,
  isTypingQuillRef,
  quillRefComponent,
  whichUserEdited,
  nameOfCurrentUser,
  interceptModifications,
  textIsChanged,
  hasGroupShared,
  whichKeyPress,
  selectionFormatText
}: ImageRichTextProps) => {
  //modules only to config quill js mirror
  //specific object into canvas modules
  const modules = React.useMemo(
    () => ({
      toolbar: false,
      clipboard: {
        matchVisual: false
      }
    }),
    []
  );
  // formats of rich text register
  //specific object into canvas modules
  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "color",
    "background",
    "align",
    "lineheight"
  ];

  //set up states
  const [isSelected, setIsSelected] = useState(false);
  const [isEditingText, setIsEditingText] = useState(false);
  const [image] = useImage(shapeProps.src, "anonymous");
  const shapeRef = useRef<Konva.Image>();
  const trRef = useRef<Konva.Transformer>();
  const rectangule = useRef<Konva.Rect>(null);
  const myWidth = useRef(shapeProps.width);
  const myHeight = useRef(shapeProps.height);
  const myPositionX = useRef(shapeProps.x);
  const myPositionY = useRef(shapeProps.y);
  const wasSelection = useRef(false);
  const myOwnText = useRef(null);
  const rectModificationsRef = useRef<Konva.Rect>(null);
  const [hasModificationsRect, setHasModificationsRect] = useState(false);
  const [positionX, setPositionX] = useState(0);

  const [widthText, setWidthText] = useState(shapeProps.width);
  const [heightText, setheightText] = useState(shapeProps.width);

  //some registers for quill enable formats
  //specific object into canvas registers
  let Parchment = Quill.import("parchment");
  let lineHeightConfig = {
    scope: Parchment.Scope.INLINE,
    whitelist: [
      "1.0",
      "1.2",
      "1.5",
      "1.6",
      "1.8",
      "2.0",
      "2.4",
      "2.8",
      "3.0",
      "4.0",
      "5.0"
    ]
  };
  //some registers for quill enable formats
  //specific object into canvas registers
  let lineHeightClass = new Parchment.Attributor.Class(
    "lineheight",
    "ql-line-height",
    lineHeightConfig
  );
  //some registers for quill enable formats
  //specific object into canvas registers
  let lineHeightStyle = new Parchment.Attributor.Style(
    "lineheight",
    "line-height",
    lineHeightConfig
  );
  Parchment.register(lineHeightClass);
  Parchment.register(lineHeightStyle);

  useEffect(() => {
    //if not have editing text or selected object difference
    //between the richtext disabled onblur function
    if (!isEditingText || !selectedObject?.attrs?.text || !selectedObject) {
      isTypingQuillRef.current = false;
    }
  }, [isEditingText, selectedObject]);

  //catch the initial delta for each object selected
  useEffect(() => {
    if (isEditingText) {
      //make sure that object have this something to compare
      //if have save to ref for findDiff function
      if (selectedObject?.attrs?.initialDelta) {
        isNewTextRef.current = false;
        let newDeltaOps = new Delta(selectedObject?.attrs?.initialDelta);
        oldContentsRef.current = newDeltaOps;
      } else {
        //if he don`t have, create empty object
        selectedObject?.setAttrs({
          initialDelta: ""
        });
        //ensuring this is new rich text
        isNewTextRef.current = true;
        // console.log(selectedObject.attrs, "eai criou?");
      }
    }
  }, [isEditingText, selectedObject]);

  // this useEffect closes the editor
  useEffect(() => {
    (async () => {
      //IF we are selecting a richtext
      if (selectedObject?.attrs?.object === "richTextImage") {
        //Apllying selection to specific richText
        if (selectedObject === shapeRef?.current) {
          setIsSelected(true);
          setIsEditing("closed");
          setTimeout(() => {
            quillRef?.current?.getEditor()?.setContents(shapeProps?.format);
          }, 0);
          currentMultipleSelection.current?.setNodes([]);
        } else {
          setIsSelected(false);
        }

        //We are using isEditingText to only get into
        //The RichText wich is the previous
        if (isEditingText) {
          await handleRenderImage();
          //closing previous quilText
          setIsEditingText(false);
          currentMultipleSelection?.current?.setNodes([]);
          return;
        }
        currentMultipleSelection?.current?.setNodes([]);
        return;
      }

      if (selectedObject === null) {
        setIsSelected(false);
        // Transform the text in an image
        if (isEditingText) {
          await handleRenderImage();
        }
        setIsEditing("closed");
        setIsEditingText(false);
        setIsSelected(false);
        return;
      }
      // From here we know that the selectedObject is not null neither a RichText
      // So we just render if there is any RichtText opened and close everything

      if (isSelected) {
        setIsSelected(false);
      }

      if (isEditingText) {
        await handleRenderImage();
        setIsEditing("closed");
        setIsEditingText(false);
        setIsSelected(false);
      }
    })();
  }, [selectedObject, shapeRef]);

  let selectionArea = useRef({
    length: 0,
    index: 0
  });

  //all this refs for algorithm of compare texts
  const mySelectionText = useRef("");
  const enableKeyWhenDiff = useRef(false);
  const beforeFormatsFontSize = useRef(null);
  const backspaceSelect = useRef(false);
  const numberKeyboardCode = useRef("");
  const specificPrevFormat = useRef<QuillText.StringMap>(null);

  //reset selection of quill js
  useEffect(() => {
    if (!selectedObject) {
      selectionArea.current = {
        index: 0,
        length: 0
      };
    }
  }, [selectedObject]);

  //listener for detect which letter
  //was pressed on keyboard event
  useEffect(() => {
    document.addEventListener("keydown", detectKeyDown, true);
  }, []);

  //this code below prevent drag and drop
  //text on quill when shared document only
  //prevent bug of review text
  useEffect(() => {
    if (isEditingText) {
      if (hasGroupShared.current) {
        document.addEventListener("drop", event => {
          event?.preventDefault();
          return false;
        });
      }
    }
  }, [isEditingText, hasGroupShared.current]);

  //add these key for used on quilljs
  const detectKeyDown = (event: KeyboardEvent) => {
    whichKeyPress.current = event.key;
    numberKeyboardCode.current = event.code;
  };

  let formatsVar: any = {};

  useEffect(() => {
    //two quills stay ready synchronim
    if (quillRefComponent.current && quillRef.current) {
      quillRef.current
        .getEditor()
        .on("selection-change", (range: QuillText.RangeStatic) => {
          if (hasGroupShared.current) {
            //get selection of selection word by user
            selectionArea.current.length = range.length;
            selectionArea.current.index = range.index;
            //verify if don`t empty because if length === 0 then
            // selection this transform to empty
            let whichLetters = quillRef.current
              .getEditor()
              .getText(range.index, range.length);
            //if exists words in variable so save it
            if (whichLetters && !enableKeyWhenDiff.current) {
              mySelectionText.current = quillRef.current
                .getEditor()
                .getText(range.index, range.length);
            }
            //ensuring that the delete key is disabled
            quillRef.current
              .getEditor()
              .keyboard.addBinding({ key: "delete" }, function () {
                //nothing to do
              });

            quillRef.current
              .getEditor()
              .keyboard.addBinding({ key: "Backspace" }, function () {
                whichKeyPress.current = "Backspace";
              });

            const formatsVar = quillRef.current.getEditor().getFormat();

            if (formatsVar.color !== "#9945ee") {
              enableKeyWhenDiff.current = false;
            }

            specificPrevFormat.current = quillRef.current
              .getEditor()
              .getFormat(selectionArea.current.index - 1, 1);

            if (range.length > 1) {
              const formatSelection = quillRef.current
                .getEditor()
                .getFormat(range.index, range.length);

              selectionFormatText.current = formatSelection;
              wasSelection.current = true;
            } else {
              wasSelection.current = false;
            }
          }
        });

      //now verify changes of editor quill
      quillRef.current.getEditor().on("editor-change", () => {
        //if  already was shared this project
        //then enable functions of reviews of texts
        if (hasGroupShared.current) {
          const selectionCurrentCursor = quillRef.current
            .getEditor()
            .getSelection();
          //verify previous formatting
          let currentFormat: QuillText.StringMap = quillRef.current
            .getEditor()
            .getFormat(selectionCurrentCursor.index - 1, 1);

          //if this new text then enable keyboard
          // for let him remove it
          if (currentFormat?.color === "#9945ee") {
            enableKeyWhenDiff.current = true;
          } else {
            //case not then prevent default
            // key backspace again
            enableKeyWhenDiff.current = false;
            quillRef.current.getEditor().update();
          }

          let textContentsAfterAnyAction = quillRef.current
            .getEditor()
            .getFormat();

          if (textContentsAfterAnyAction.size) {
            beforeFormatsFontSize.current = textContentsAfterAnyAction.size;
          }

          if (selectionArea.current.length === 0) {
            //if selection area of cursor is > 0
            //so user use selection then prevent behavior of key
            quillRef.current
              .getEditor()
              .keyboard.addBinding(
                { key: "backspace" },
                function (range: QuillText.RangeStatic) {
                  //verify if have is keyboard enable or not
                  if (enableKeyWhenDiff.current) {
                    let selection = quillRef.current.getEditor().getSelection();

                    quillRef.current
                      .getEditor()
                      .deleteText(selection.index - 1, 1);

                    //then enable keyboard
                    return true;
                  } else {
                    backspaceSelect.current = true;
                    //so disable keyboard and
                    //if have selection of cursor
                    if (range.length > 0) {
                      // console.log("caiu no length maior q zero");
                      //just transform that text by deleted text format
                      quillRef.current
                        .getEditor()
                        .formatText(
                          range.index,
                          range.length,
                          "color",
                          "#DE2D2D"
                        );
                    } else {
                      //if is tap default backspace on just one time
                      //so bring up cursor to new position and keep the text
                      if (range.index <= 1) {
                        let keyboard = quillRef.current
                          ?.getEditor()
                          ?.getModule("keyboard");
                        if (keyboard) {
                          keyboard.bindings["backspace"] = null;
                          keyboard.bindings["8"] = null;
                          keyboard.bindings["delete"] = null;
                          keyboard.bindings["46"] = null;
                        }
                        quillRef.current
                          .getEditor()
                          .formatText(0, 1, "color", "#DE2D2D");
                        quillRef.current.getEditor().setSelection(0, 0);
                      } else {
                        formatsVar = quillRef.current.getEditor().getFormat();

                        let keyboard = quillRef.current
                          ?.getEditor()
                          ?.getModule("keyboard");
                        if (keyboard) {
                          keyboard.bindings["backspace"] = null;
                          keyboard.bindings["8"] = null;
                          keyboard.bindings["delete"] = null;
                          keyboard.bindings["46"] = null;
                        }

                        quillRef.current
                          .getEditor()
                          .setSelection(range.index - 1, range.length);
                        // and lets go formating to red
                        quillRef.current
                          .getEditor()
                          .formatText(
                            range.index === 1 ? 0 : range.index - 1,
                            range.length > 0 ? range.length : 1,
                            "color",
                            "#DE2D2D"
                          );

                        return null;
                      }
                    }
                  }
                }
              );
          } else {
            if (formatsVar.color === "#9945ee") {
              enableKeyWhenDiff.current = true;
            } else {
              quillRef.current
                .getEditor()
                .keyboard.addBinding({ key: "backspace" }, range => {
                  quillRef.current
                    .getEditor()
                    .setSelection(range.index - 1, range.length);
                  // and lets go formating to red
                  quillRef.current
                    .getEditor()
                    .formatText(
                      range.index === 1 ? 0 : range.index - 1,
                      range.length > 0 ? range.length : 1,
                      "color",
                      "#DE2D2D"
                    );
                });
            }
          }
        }
      });

      quillRefComponent.current.getEditor()!.root!.style!.padding = "0px";
      quillRefComponent.current.getEditor()!.root!.style!.margin = "0px";

      isTypingQuillRef.current = true;
      interceptModifications.current = false;

      quillRef.current?.getEditor()?.on("text-change", delta => {
        wasSelection.current = false;
        let myText = quillRef.current.getEditor().getText();
        let textLength = myText.length;

        // prevent history undo or redo when
        // shared document to prevent bug of mark text changed
        const history = quillRef.current.getEditor().getModule("history");
        if (hasGroupShared.current) {
          history.options.maxStack = 0;
        }

        //prevent default keyboard behavior
        //when key down blackspace
        //only if document was shared
        if (hasGroupShared.current && !enableKeyWhenDiff.current) {
          //by having ensure if cursor selections in use
          if (selectionArea?.current?.length > 0) {
            if (selectionArea.current.length + 1 === textLength) {
              //keep formats when delete all text
              if (whichKeyPress.current === "Backspace") {
              }
            }

            //before action, disable this selection
            quillRef.current.getEditor().setSelection({
              index: selectionArea.current.index,
              length: 0
            });
          }
          //get selection of cursor
          const selectionType = quillRef.current.getEditor().getSelection();
          //move to the left cursor variable
          let count = selectionType.index - 1;

          // if the change was an insertion
          delta.forEach(op => {
            if (op.insert && whichKeyPress.current !== "Backspace") {
              //add new formats to insert text
              if (selectionType.length === 0) {
                quillRef.current
                  .getEditor()
                  .formatText(count, 1, "color", "#9945EE");
              }
            }

            // when user deleted something without
            //the backspace detect this text for save it
            if (op.hasOwnProperty("delete")) {
              // textIsChanged.current = true;
              //ensure new letter was a pressed format of insert
              if (
                mySelectionText.current &&
                whichKeyPress.current !== "Backspace"
              ) {
                quillRef.current
                  .getEditor()
                  .formatText(count + 1, 1, "color", "#9945EE");

                if (specificPrevFormat.current.color) {
                  quillRef.current
                    .getEditor()
                    .formatText(
                      count,
                      1,
                      "color",
                      specificPrevFormat.current.color
                    );
                } else {
                  quillRef.current
                    .getEditor()
                    .formatText(count, 1, "color", "#000");
                }
              }

              if (whichKeyPress.current !== "Backspace") {
                //brings the selection user
                quillRef.current.getEditor().setSelection({
                  index: selectionType.index + 1,
                  length: 0
                });
              }

              if (whichKeyPress.current === "Backspace") {
                //to do if backspace
              }

              let currentSelection = quillRef.current
                .getEditor()
                .getSelection();

              //length of text was a capture by event of selection
              let lengthText = mySelectionText.current.length;
              //and then apply this text and formats deleted
              //text for keep it
              quillRef.current
                .getEditor()
                .insertText(currentSelection.index, mySelectionText.current);

              quillRef.current
                .getEditor()
                .formatText(
                  currentSelection.index,
                  lengthText,
                  "color",
                  "#DE2D2D"
                );

              //generate new selection
              quillRef.current
                .getEditor()
                .setSelection({ index: currentSelection.index, length: 0 });
              //reset text save in memory variable
              mySelectionText.current = "";
            }
          });
        }
        //assign the text aside screen to load formats into rich text
        //inside of canvas
        quillRefComponent.current
          ?.getEditor()
          ?.setContents(quillRef.current?.getEditor().getContents());
        //save it into new variable to use it others modules this code
        myOwnText.current = cloneDeep({
          ...quillRef.current?.getEditor().getContents()
        });
        // getting height from quill and aplying to rectangule
        myHeight.current =
          quillRefComponent?.current?.getEditor()?.root?.offsetHeight;
        rectangule?.current?.height(myHeight?.current);
        //apply to newContents this actually delta
        newContentsRef.current = myOwnText.current;
      });
    }
  }, [isEditingText]);

  //useEffect used for blocking the keyboard when editor is open
  useEffect(() => {
    if (isEditing === "open") {
      setBlockingKeyboard(true);
    } else if (isEditing === "closed" || isEditing === "blocked") {
      setBlockingKeyboard(false);
    }
  }, [isEditing]);

  // applying transformer to rectangule
  useEffect(() => {
    trRef.current?.setNodes([rectangule.current]);
    trRef.current?.setZIndex(trRef.current.getParent().children.length - 1);
    trRef.current?.getLayer().batchDraw();
  }, [isSelected]);

  const handleEdit = useCallback(() => {
    setTimeout(() => {
      // getting absolute postion from rectangule to apply on quillEditor
      let absPostion = rectangule.current.getAbsolutePosition();
      myPositionX.current = absPostion.x;
      myPositionY.current = absPostion.y;
      setPositionX(0);
      setIsEditing("open");
      setIsEditingText(true);

      //Getting Formats from JSON and applying to quilRefComponent and quilRef
      quillRefComponent?.current
        ?.getEditor()
        ?.setContents(selectedObject.attrs.format);
      quillRef.current.getEditor().setContents(selectedObject.attrs.format);
      quillRef.current.getEditor().update();
      quillRefComponent.current.getEditor().update();
    }, 0);
  }, [
    isEditingText,
    isEditing,
    shapeProps,
    quillRef,
    quillRefComponent,
    myPositionX,
    myPositionY,
    selectedObject,
    setPositionX
  ]);

  //this callback to use it when we have generate image to richtext
  const handleRenderImage = async () => {
    try {
      // if there was any modification in the text editor save it to the history
      if (shapeProps.text !== quillRefComponent.current.getEditor().getText()) {
        await addToHistory();
      }

      let myFormatText = quillRefComponent.current?.getEditor()?.getContents();

      // this code below verify if have modifications
      // on each richText to mark him
      if (hasGroupShared.current) {
        const imageContents = quillRefComponent.current
          ?.getEditor()
          ?.getContents();
        textIsChanged.current =
          imageContents?.ops?.filter(
            op =>
              op?.attributes?.color === "#9945ee" ||
              op?.attributes?.color === "#de2d2d"
          ).length > 0;
      }
      //define device pixel ratio for better resolution
      window.devicePixelRatio = 2;
      //use html2canvas for generate base64
      const canvas = await html2canvas(
        quillRefComponent.current.getEditor().root,
        {
          backgroundColor: null,
          scale: 5
        }
      );

      let myImageSrc = canvas.toDataURL("image/webp", 1);
      let myText = quillRefComponent.current?.getEditor()?.getText();
      //now we have offset height of rich text inside canvas to
      //transformer of rectangle konva
      if (quillRefComponent.current?.getEditor()?.root?.offsetHeight) {
        myHeight.current =
          quillRefComponent.current?.getEditor()?.root?.offsetHeight;
      }
      //add to state new modifications as src image, formats,
      // width, height and more...
      if (myFormatText) {
        setObjectScreen(prevState => {
          let cloneState = cloneDeep(prevState);
          cloneState.forEach(page => {
            page.renderObjects.forEach(object => {
              if (object.id === shapeProps.id) {
                object.x = myPositionX.current;
                object.y = myPositionY.current;
                object.scaleX = 1;
                object.scaleY = 1;
                object.width = widthText;
                object.height = myHeight.current;
                object.src = myImageSrc;
                object.text = myText;
                object.format = myFormatText;
                if (!interceptModifications.current && hasGroupShared.current) {
                  object.idOfUserEdited =
                    textIsChanged.current &&
                    hasGroupShared.current &&
                    !object.isModify
                      ? whichUserEdited.current
                      : object?.idOfUserEdited;
                  object.nameOfUserEdited =
                    textIsChanged.current &&
                    hasGroupShared.current &&
                    !object.isModify
                      ? nameOfCurrentUser.current
                      : object?.nameOfUserEdited;

                  object.isModify =
                    textIsChanged.current && hasGroupShared.current
                      ? true
                      : false;
                }
              }
            });
          });
          textIsChanged.current = false;
          return cloneState;
        });
      }
      setPositionX(0);
    } catch (error) {
      console.log(error);
    }
  };

  //this one callback will be called when end mouse drag end event
  //to ensure that we are modifying position of object rich text image
  const handleDragEnd = useCallback(
    (event: Konva.KonvaEventObject<MouseEvent>) => {
      setHasModificationsRect(false);
      setObjectScreen(prevState => {
        let cloneState = cloneDeep(prevState);
        cloneState.forEach(page => {
          page.renderObjects.forEach(object => {
            if (object.id === event.target.id()) {
              rectangule?.current?.setPosition(event.target.absolutePosition());
              myPositionX.current = event.target.absolutePosition().x;
              myPositionY.current = event.target.absolutePosition().y;
              object.x = event.target.absolutePosition().x;
              object.y = event.target.absolutePosition().y;
            }
          });
        });

        return cloneState;
      });
    },
    []
  );

  //here will be the image representing the text
  return (
    <>
      {!isEditingText && (
        <>
          <ImageKonva
            image={image}
            ref={shapeRef}
            {...shapeProps}
            name="richTextImage"
            onDblClick={handleEdit}
            onClick={(event: Konva.KonvaEventObject<MouseEvent>) => {
              setWidthText(shapeProps.width);
              //checking if the object has multiple active objects
              const isTargetInsideMultipleSelection =
                currentMultipleSelection.current
                  ?.nodes()
                  .includes(event.target);

              if (isTargetInsideMultipleSelection) {
                //then remove selected object
                setSelectedObject(null);
              } else {
                //if only one object let empty multiple objects
                //and update with width and height of shapes
                //to transformer for example
                setSelectedObject(event.target);
                currentMultipleSelection.current?.setNodes([]);
                myWidth.current = shapeProps.width;
                myHeight.current = shapeProps.height;

                setWidthText(shapeProps.width);
              }
            }}
            onDragStart={event => {
              //checking if the object has multiple active objects
              //always add to history for undo and redo function
              if (
                currentMultipleSelection.current?.nodes().length === 0 ||
                !currentMultipleSelection.current
              ) {
                addToHistory();
              }

              const isTargetInsideMultipleSelection =
                currentMultipleSelection.current
                  ?.nodes()
                  .includes(event.target);

              //if mutipleSelection includes element being dragged
              if (isTargetInsideMultipleSelection) {
                setSelectedObject(null);
              } else {
                setSelectedObject(shapeRef.current);
                currentMultipleSelection.current?.setNodes([]);
              }
            }}
            onDragMove={(event: Konva.KonvaEventObject<MouseEvent>) => {
              //set a new position for the rectangle to follow the image
              //checking if the object has multiple active objects
              if (
                currentMultipleSelection.current?.nodes().length === 0 ||
                !currentMultipleSelection.current
              ) {
                rectangule.current.setAbsolutePosition({
                  ...event.target.getAbsolutePosition()
                });
              }
            }}
            onDragEnd={handleDragEnd}
          />
          {/*used only when text has been shared and modified */}
          {shapeProps.isModify && !hasModificationsRect && (
            <Rect
              ref={rectModificationsRef}
              width={1}
              height={shapeProps?.height}
              x={shapeProps?.x - 8}
              y={shapeProps?.y}
              fill={"red"}
              onDragMove={(event: Konva.KonvaEventObject<MouseEvent>) => {
                //linking image moviment with transformer
                if (isSelected) {
                  shapeRef.current?.setAbsolutePosition({
                    ...event.target?.getAbsolutePosition()
                  });
                }
              }}
              onDragStart={event => {
                if (
                  currentMultipleSelection.current?.nodes().length === 0 ||
                  !currentMultipleSelection.current
                ) {
                  addToHistory();
                }

                const isTargetInsideMultipleSelection =
                  currentMultipleSelection.current
                    ?.nodes()
                    .includes(event.target);

                //if mutipleSelection includes element being dragged
                if (isTargetInsideMultipleSelection) {
                  setSelectedObject(null);
                } else {
                  setSelectedObject(shapeRef.current);
                  currentMultipleSelection.current?.setNodes([]);
                }
              }}
              onDragEnd={handleDragEnd}
            />
          )}
        </>
      )}

      {isSelected && (
        <Transformer
          ref={trRef}
          rotateEnabled={false}
          enabledAnchors={isEditingText ? ["middle-right", "middle-left"] : []}
          onTransformStart={() => {
            if (
              currentMultipleSelection.current?.nodes().length === 0 ||
              !currentMultipleSelection.current
            ) {
              //addToHistory();
              setIsEditing("open");
              setIsEditingText(true);
            }
          }}
          onTransform={(event: Konva.KonvaEventObject<MouseEvent>) => {
            //when transform we want to resize quill rich text
            let whichTransform = trRef.current?.getActiveAnchor();
            //manipulate specific anchor left for text
            if (whichTransform === "middle-left") {
              //get width of transformer of rich text inside canvas
              let width = trRef.current.getWidth();

              //get height of rich text inside canvas when changing
              if (event.target.height) {
                event.target.height(
                  quillRefComponent.current.getEditor()?.root?.offsetHeight
                );
              }
              //get position x and y
              let position = event.target.getAbsolutePosition();
              myPositionX.current = position.x;
              setPositionX(position.x);

              //add to rich text new width
              quillRefComponent.current.getEditor().root.style.width = `${width}px`;
            } else {
              //if you are modifying right anchor
              //pass height of rich text to transformer

              myHeight.current = trRef?.current?.height();

              let width = trRef.current.getWidth();
              setWidthText(oldState => width);

              if (event.target.height) {
                event.target.height(
                  quillRefComponent.current.getEditor()?.root?.offsetHeight
                );
              }
              //update width of rich text with of transformer konva
              quillRefComponent.current.getEditor().root.style.width = `${widthText}px`;
            }
          }}
          onTransformEnd={(event: Konva.KonvaEventObject<MouseEvent>) => {
            let rotation = trRef?.current.rotation();
            setWidthText(event.currentTarget.width());
            myHeight.current = trRef?.current?.height();
            window.devicePixelRatio = 2;
            let myFormats = quillRef?.current?.getEditor()?.getContents();
            // Transforming QuilText to Image and applying
            // modifications to state
            html2canvas(quillRefComponent.current.getEditor()?.root, {
              backgroundColor: null,
              scale: 5
            })
              .then(canvas => {
                if (myFormats) {
                  let myImageSrcText = canvas.toDataURL("image/webp", 1);

                  rectangule.current?.scaleX(1);
                  rectangule.current?.scaleY(1);

                  setObjectScreen(prevState => {
                    let cloneState = cloneDeep(prevState);
                    cloneState.forEach(page => {
                      page.renderObjects.forEach(object => {
                        if (object.id === shapeProps.id) {
                          object.scaleX = event.target?.scaleX();
                          object.scaleY = event.target?.scaleY();
                          object.width = widthText;
                          object.height = event.target.height();
                          object.x = event.target.absolutePosition()?.x;
                          object.y = event.target.absolutePosition()?.y;
                          object.src = myImageSrcText;
                          object.rotation = rotation;
                          object.format = myFormats;
                        }
                      });
                    });

                    return cloneState;
                  });
                }
              })
              .catch(error => {
                console.log(error);
              });
          }}
          boundBoxFunc={(oldBox, newBox) => {
            // limit resize
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}

      {/*this is the quill that we display inside
       the canvas simulating the text */}
      {isEditingText && (
        <Html>
          <div className="quillRefMirrorClass">
            <ReactQuill
              ref={quillRefComponent}
              modules={modules}
              formats={formats}
              readOnly
              id="SAMEQUILL"
              // className="noselect"
              style={{
                position: "absolute",
                top: `${myPositionY.current}px`,
                left:
                  positionX === 0
                    ? `${myPositionX.current}px`
                    : `${positionX}px`,
                width: `${widthText}px`,
                height: `${myHeight.current}px`,
                padding: "0",
                background: "rgba(0, 0, 0, 0)"
              }}
              theme="snow"
            />
          </div>
        </Html>
      )}

      {isSelected && (
        <Rect
          x={shapeProps.x}
          y={shapeProps.y}
          id={shapeProps.id}
          onDblClick={handleEdit}
          ref={rectangule}
          draggable={shapeRef.current?.draggable()}
          width={widthText}
          height={myHeight.current}
          //onDragStart={handleDragStart}
          onDragMove={(event: Konva.KonvaEventObject<MouseEvent>) => {
            //linking image moviment with transformer
            if (isSelected) {
              shapeRef.current?.setAbsolutePosition({
                ...event.target?.getAbsolutePosition()
              });
            }
          }}
          onDragStart={event => {
            if (hasGroupShared.current) {
              setHasModificationsRect(true);
            }
            if (
              currentMultipleSelection.current?.nodes().length === 0 ||
              !currentMultipleSelection.current
            ) {
              addToHistory();
            }

            const isTargetInsideMultipleSelection =
              currentMultipleSelection.current?.nodes().includes(event.target);

            //if mutipleSelection includes element being dragged
            if (isTargetInsideMultipleSelection) {
              setSelectedObject(null);
            } else {
              setSelectedObject(shapeRef.current);
              currentMultipleSelection.current?.setNodes([]);
            }
          }}
          onDragEnd={handleDragEnd}
        />
      )}
    </>
  );
};

export default ImageRichText;
